export const environment = {
  production: false,
  // true = gọi Firebase Functions emulator (localhost:5001) khi test reset mật khẩu local.
  useEmulators: false,
  firebase: {
    apiKey: "AIzaSyC-mjeMH2fVs0CQkg3OGU9tNBLFeQZ8hFQ",
    authDomain: "chocaulongvietnam.firebaseapp.com",
    projectId: "chocaulongvietnam",
    storageBucket: "chocaulongvietnam.firebasestorage.app",
    messagingSenderId: "483119773062",
    appId: "1:483119773062:web:2bc67d585303037822e807",
    measurementId: "G-QPSNK8KQ21"
  },
};
